import { render, staticRenderFns } from "./UiFormatPrice.vue?vue&type=template&id=68de9c0a"
import script from "./UiFormatPrice.vue?vue&type=script&lang=js"
export * from "./UiFormatPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports